import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconSubtrac = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="1000.000000pt"
      height="512.000000pt"
      viewBox="0 0 1000.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(50.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2180 2911 c-83 -26 -160 -97 -203 -189 -27 -57 -31 -78 -31 -152 -1
-47 5 -105 12 -130 29 -100 131 -206 222 -230 25 -7 794 -9 2341 -8 l2304 3
40 22 c64 34 124 99 157 170 26 56 31 77 32 151 0 48 -5 107 -12 132 -29 99
-130 205 -220 230 -44 12 -4602 13 -4642 1z"
        />
      </g>
    </svg>
  );
};

export default IconSubtrac;
